import { Counter, RadioButton } from "../../components";
import { PaymentFrequencyState, StoreConfigState } from "../../utils/interfaces/storelogo";
import productConstant from "../../pages/products/constants.json";
import { mtm_getUtmParamsFromSession } from "../../utils/utility";

interface CounterSubsLayoutProps {
  paymentFrequencyConfig: PaymentFrequencyState;
  attorneySize: number;
  setAttorneySize: (value: number) => void;
  subscriptionType: string;
  setSubscriptionType: (value: string) => void;
  storeData: StoreConfigState;
  changeContractLength: (value: string) => void;
  contractLength: string;
}

const CounterSubsLayout = (props: CounterSubsLayoutProps) => {
  const {
    attorneySize,
    setAttorneySize,
    storeData,
    changeContractLength,
    contractLength,
    paymentFrequencyConfig,
  } = props;

  const billingTypes = paymentFrequencyConfig.contract_details_json.contract_details.map(detail =>
    detail.subscription_type === "MONTHLY"
      ? "Billed Monthly"
      : detail.subscription_type === "YEARLY"
      ? "Billed Annually"
      : ""
  );

  return (
    <>
      <div className="home-page-price-selector">
        <Counter
          val={attorneySize}
          changeVal={setAttorneySize}
          title={storeData.attorney_label}
          min={1}
          max={storeData.number_of_attorney}
          message={storeData.attorney_tooltip_info}
        />
        <RadioButton
          label={paymentFrequencyConfig.subscription_label}
          buttons={paymentFrequencyConfig.contract_details_json?.contract_details}
          discounts={paymentFrequencyConfig?.discount_details_json?.discount_details?.fixed_package}
          checked={contractLength}
          onChange={changeContractLength}
          billingTypes={billingTypes}
        />
      </div>
      <div className="px-6">
        {storeData.number_of_attorney === 5 &&
          props.attorneySize === storeData.number_of_attorney && (
            <div
              data-track="contact-us-button"
              className="flex items-start lg:items-center mb-6 flex-col lg:flex-row "
            >
              <p className="text-primary-red">
                {productConstant.counterInfoError.description.replace(
                  "%d",
                  storeData.number_of_attorney.toString()
                )}
              </p>
               <a href={
                    mtm_getUtmParamsFromSession()
                      ? `https://www.lexisnexis.com/en-us/professional/usc/contact.page${mtm_getUtmParamsFromSession()}`
                      : "https://www.lexisnexis.com/en-us/professional/usc/contact.page"         
                  }
                  target="_blank">
                <button className="mt-5 lg:mt-0 lg:ml-5 px-4 py-0 h-12 text-heading font-black border-2 border-solid border-blues-midnight rounded">
                  {productConstant.counterInfoError.btnText}
                </button>
              </a>
            </div>
          )}
      </div>
    </>
  );
};

export default CounterSubsLayout;
